<template>
    <div class="o-layout o-layout--center">
        <div class="c-panel">

            <div class="c-logo margin-b-40">
                <img src="/img/logo/logo-text.svg" width="126" height="40">
            </div>

            <h2 class="margin-b-24">Account activeren</h2>

            <c-form ref="form" @valid="submit" :autocomplete="'off'">

                <c-form-element
                    :label="'Wachtwoord'"
                    :icon="true"
                    :password="true"
                    @password="hidePassword">
                    <input
                        :type="passwordHidden ? 'password': 'text'"
                        v-model="password"
                        data-pattern="password"
                        data-error-message="Je wachtwoord moet minimaal uit 1 hoofdletter, 1 kleine letter, 1 cijfer en 1 speciale karakter. Tevens moet het wachtwoord 8 karakters lang zijn"
                        required
                        id="password"
                        name="password"
                        autocomplete="new-password"/>
                </c-form-element>

                <c-form-element
                    :label="'Herhaal wachtwoord'"
                    :icon="true"
                    :password="true"
                    @password="hideConfirm">
                    <input
                        :type="confirmHidden ? 'password': 'text'"
                        v-model="password_confirmation"
                        data-pattern="password"
                        data-equalto="password"
                        required name="confirm"
                        autocomplete="new-password"/>
                </c-form-element>

                <c-form-element>
                    <template
                        v-for="voorwaarde in voorwaarden"
                    >
                        <c-checkbox
                            :required="true"
                            v-model="acceptedTerms[voorwaarde.doelgroep]"
                            :label="'Ik ga akkoord met de ' + voorwaarde.doelgroep + '-voorwaarden'"></c-checkbox>
                        <a
                            @click="tekst=voorwaarde.tekst; modal=true"
                        >Voorwaarden {{voorwaarde.doelgroep}}</a>
                    </template>
                </c-form-element>

                <p class="color-alert" v-if="error">Helaas konden we je account niet activeren.</p>

                <button type="submit" class="c-btn c-btn--expanded margin-t-32" ref="submit">Account activeren</button>

            </c-form>

    <c-modal @close="modal=false" :title="'Voorwaarden'" v-show="modal">
        <div v-html="tekst"></div>
    </c-modal>

        </div>
    </div>
</template>

<script>
    import Form from '@mixins/Form';
import xhr from '../../xhr';
import CModal from '@components/Modal';

    export default {
        components: {CModal },
        mixins: [ Form ],
        data() {
            return {
                modal: false,
                error: false,
                password: '',
                password_confirmation: '',
                passwordHidden: true,
                confirmHidden: true,
                voorwaarden: [],
                acceptedTerms: [],
                tekst: "",
            }
        },
        computed: {
            termstext() {
                return 'Ik ga akkoord met de <a href="https://www.sigv.nl/" target="_blank">algemene voorwaarden</a>';
            }
        },
        methods: {
            hidePassword(show) {
                this.passwordHidden = !show;
            },

            hideConfirm(show) {
                this.confirmHidden = !show;
            },
            submit() {

                this.$store.dispatch('registration/password', {
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    accepted_terms: this.acceptedTerms,
                    token: this.$route.params.token
                });

                this.$store.dispatch('registration/send').then( () =>{
                    this.$router.push({name:'verification'});
                });
            },
        },
        created() {
            this.$xhr.get('/api/auth/voorwaarden/', {token: this.$route.params.token})
            .then(result => this.voorwaarden = result.result)
            .catch(() =>this.$store.dispatch('toasts/alert', {title: 'Voorwaarden', text: 'Helaas konden we geen voorwaarden vinden.'}));
        },
    }
</script>
